import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'paymentStatus',
    standalone: false
})
export class PaymentStatusPipe implements PipeTransform {

  constructor(private translateService: TranslateService) {}

  transform(value: number | string | boolean): string {
    const statoNonPagato = this.translateService.instant('stato-non-pagato');
    const statoPagato = this.translateService.instant('stato-pagato');
    const statoSconosciuto = this.translateService.instant('stato-sconosciuto');

    if (value === 0 || value === '0' || value === false) {
      return statoNonPagato;
    } else if (value === 1 || value === '1' || value === true ) {
      return statoPagato;
    } else {
      return statoSconosciuto;
    }
  }
}
